<template>
  <div>
    <div>
      <!-- Home page content -->
      <main role="main">
        <div class="banner-btm">
          
        <div class="text-center pt-4 container">
          <h1 class="text-center" v-html="$t('Home.BannerTitle')">
          </h1>
          <p class="page-subheader mb-0" v-html="$t('Home.BannerDesc')"></p>
        </div>
          <div class="text-center readytosubmit container">
          <div class="row d-flex justify-content-between align-items-center">
            <div class="col-sm-12 text-sm-center">
              <div class="col-sm-12">
                <div class="my-4 py-1">
                  <router-link to="/Upload" class="btn btn-link">
                    {{ $t('Home.GetStartedBtn') }}</router-link
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 mb-2">
              <small v-html="$t('Home.ParticipatingProductLink')" @click="handleLinkClick"></small>
            </div>
            <div class="col-sm-12">
              <small v-html="$t('Home.HavingTroubleLink')" @click="handleLinkClick"></small>
            </div>
          </div>
        </div>
      </div>
        <div class="how-to-blk">
          <div class="container">
        <h2 class="text-center mb-md-5 mb-4">{{ $t('Home.HowToParticipateTitle') }}</h2>
        <div class="row text-center d-flex justify-content-center">
          <div class="col-md-3 home-card-bg">
            <div class="home-card">
              <img
                src="https://snippcheck.blob.core.windows.net/files/ArmHammer_2008526_CatLitterRebate/shop.png"
                :alt="$t('Home.ShopTitle')"
                class="img-fluid mb-3"
              />
              <h4>{{ $t('Home.ShopTitle') }}</h4>
              <p>
                <small v-html="$t('Home.ShopDetail')"></small>
              </p>
            </div>
          </div>

          <div class="col-md-3 home-card-bg">
            <div class="home-card">
              <img
                src="https://snippcheck.blob.core.windows.net/files/ArmHammer_2008526_CatLitterRebate/snap.png"
                :alt="$t('Home.SnapTitle')"
                class="img-fluid mb-3"
              />
              <h4>{{ $t('Home.SnapTitle') }}</h4>
              <p>
                <small v-html="$t('Home.SnapDetail')"></small>
              </p>
            </div>
          </div>
          <div class="col-md-3 home-card-bg">
            <div class="home-card">
              <img
                src="https://snippcheck.blob.core.windows.net/files/ArmHammer_2008526_CatLitterRebate/upload.png"
                :alt="$t('Home.SendTitle')"
                class="img-fluid mb-3"
              />
              <h4>{{ $t('Home.SendTitle') }}</h4>
              <p>
                <small v-html="$t('Home.SendDetail')"></small>
              </p>
            </div>
          </div>
           <div class="col-md-3 home-card-bg">
            <div class="home-card">
              <img
                 src="https://snippcheck.blob.core.windows.net/files/ArmHammer_2008526_CatLitterRebate/get.png"
                :alt="$t('Home.GetTitle')"
                class="img-fluid mb-3"
              />
              <h4>{{ $t('Home.GetTitle') }}</h4>
              <p>
                <small v-html="$t('Home.GetDetail')"></small>
              </p>
            </div>
          </div> 
        </div>
      </div>
        </div>
       
        
      </main>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    startDate: {
      type: Date,
      required: true,
    },
    endDate: {
      type: Date,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
  // New method: make <a> behave like router-links
  handleLinkClick(event) {
    const target = event.target.closest('a');
    if (target) {
      const href = target.getAttribute('href');

      // Only intercept internal links (those starting with '/')
      if (href && href.startsWith('/')) {
        event.preventDefault();
        this.$router.push(href);
      }
    }
  },
}
};
</script>

<style scoped>
@media screen and (max-width: 575px) {
}
</style>

<style scoped>
/* .home-card-bg {
  position: relative;
}
.home-card {
  box-shadow: 0 15px 25px rgba(129, 124, 124, 0.2);
  height: 380px;
  border-radius: 19px;
  backdrop-filter: blur(14px);
  background-color: rgb(255 255 255 / 20%);
  padding: 15px;
  text-align: left;
  line-height: 23px;
  font-size: 1.2rem;
}
.home-card-bg:before {
  content: '';
  position: absolute;
  height: 70px;
  width: 70px;
  top: -9px;
  left: 5px;
  background-color: #bf233a;
  border-radius: 18px;
}
.home-card img {
  height: 70px;
} */
/* .readytosubmit {
  background: #bf233a2b;
  border: 1px solid #bf233a;
  border-radius: 10px;
  padding: 20px 30px;
} */
@media screen and (max-width: 575px) {
  .home-card {
    height: auto;
    margin-bottom: 40px;
  }
}
</style>
